import { Table, TableColumnsType, TablePaginationConfig } from 'antd'
import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

interface TableProps extends RouteComponentProps {
    columns?: TableColumnsType<any>
    data?: any[]
    onRow?: (record: any, index?: number) => React.HTMLAttributes<any> | React.TdHTMLAttributes<any>
    loading?: boolean
    expandedRowRender?: ((record: any, index: number, indent: number, expanded: boolean) => React.ReactNode) | undefined
    pagination?: TablePaginationConfig
}

const Component: React.FC<TableProps> = (props) => {
    return (
        <Table
            columns={props.columns}
            dataSource={props.data}
            onRow={props.onRow}
            loading={props.loading}
            expandedRowRender={props.expandedRowRender}
            scroll={{ x: 'max-content' }}
            pagination={props.pagination}
        />
    )
}

export default withRouter(Component)
